"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeIdResolver = void 0;

var _ReferenceRecord = _interopRequireDefault(require("../schema/ReferenceRecord"));

var _Strategy = require("./Strategy");

var _isString = _interopRequireDefault(require("transmute/isString"));

var _isNumber = _interopRequireDefault(require("transmute/isNumber"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _enforce = require("../lib/enforce");

var makeIdResolver = (0, _Strategy.makeKeyedResolver)({
  idTransform: function idTransform(id) {
    (0, _invariant.default)((0, _isString.default)(id) || (0, _isNumber.default)(id), 'expected reference id to be a string but found `%s`', id);
    return String(id);
  },
  valueTransform: (0, _enforce.createEnforceResolverValue)('ReferenceRecord', _ReferenceRecord.default.isReferenceRecord)
});
exports.makeIdResolver = makeIdResolver;